import { default as calculationjr1tcZks6XMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailfOCKOrPNcAMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryerunBaTKDiMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_935bsuI4sJtsMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45list42btg77DnkMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingyG7pPpU9C1Meta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyougrSWeRL4bYMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellYxbY8IbRDXMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostlaRFUqZ5jhMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankDOIkw3AmywMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnani4dckoRZ4UqMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pagetEjZx7Z5hBMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testOSNLScb9qGMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepageyVpudY7F30Meta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleVNzjLWIHEZMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patterns1q3CPPD2gDMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tag24i5VQh5LgMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorFJ8PI5v8i7Meta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryDTfui8yry5Meta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionWTNhYyu7RIMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesKVaYtUEIUvMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryj7nXdxQCOiMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleudGrLWjLXoMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionqzgTJHmdGLMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as car_45insurance_45terminationtRjHK8k9t6Meta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationFHbE6dZe5MMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youJuvY3yT4T9Meta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detaildrfc9kcwkSMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryLny9wIwRZFMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listFow3ZiclMTMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationaSO8sMJGUTMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youD07FmPDgUSMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquirybsUUsnaXSUMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listb4UC8tbW6BMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailOxTreb9xpHMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offeriAJlbDAd5MMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryqOIcSsf0neMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45you3lRuvzU4nsMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculation73IknYhRFrMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listu9EkHy4CZuMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youlIzqplnFJdMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlinebAIt6VM7ajMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detail9CpODABzOzMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phonegqMfu6ZWDlMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerDkW2KUxSaWMeta } from "/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani-ab/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostlaRFUqZ5jhMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankDOIkw3AmywMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnani4dckoRZ4UqMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pagetEjZx7Z5hBMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testOSNLScb9qGMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepageyVpudY7F30Meta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleVNzjLWIHEZMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patterns1q3CPPD2gDMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tag24i5VQh5LgMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorFJ8PI5v8i7Meta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryDTfui8yry5Meta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionWTNhYyu7RIMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesKVaYtUEIUvMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pagetEjZx7Z5hBMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryj7nXdxQCOiMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleudGrLWjLXoMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionqzgTJHmdGLMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionqzgTJHmdGLMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: car_45insurance_45terminationtRjHK8k9t6Meta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationFHbE6dZe5MMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youJuvY3yT4T9Meta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detaildrfc9kcwkSMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryLny9wIwRZFMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listFow3ZiclMTMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationaSO8sMJGUTMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youD07FmPDgUSMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquirybsUUsnaXSUMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listb4UC8tbW6BMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailOxTreb9xpHMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offeriAJlbDAd5MMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryqOIcSsf0neMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45you3lRuvzU4nsMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculation73IknYhRFrMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listu9EkHy4CZuMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youlIzqplnFJdMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlinebAIt6VM7ajMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detail9CpODABzOzMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phonegqMfu6ZWDlMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerDkW2KUxSaWMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src1361780033/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]